<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>Vendor</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content class="px-3 py-4">
  <p>{{ vendor.name }}</p>

  <ng-container>
    <h6>Phone</h6>
    <p *ngIf="vendor.phone"><a [href]="'tel:' + vendor.phone_e164" target="_blank">{{ vendor.phone }}</a></p>
  </ng-container>

  <ng-container>
    <h6>Email</h6>
    <p *ngIf="vendor.email"><a [href]="'mailto:' + vendor.email" target="_blank">{{ vendor.email }}</a></p>
  </ng-container>

  <ng-container *ngIf="vendor.website">
    <h6>Website</h6>
    <p><a [href]="vendor.website" target="_blank">{{ vendor.website }}</a></p>
  </ng-container>

  <ng-container *ngIf="vendor.insurance_valid_till">
    <h6>Insurance Expiry Date</h6>
    <p><span [style.color]="utils.getDueDateColor(vendor.insurance_valid_till) || null">
      {{ vendor.insurance_valid_till | timezoneConvertMedium }}
    </span></p>
  </ng-container>

  <ng-container>
    <h6>Prequalified</h6>
    <p>{{ vendor.is_prequalified ? 'Yes' : 'No' }}</p>
  </ng-container>

  <ng-container *ngIf="vendor.prequalified_date">
    <h6>Pre-Qualified Date</h6>
    <p>{{ vendor.prequalified_date | timezoneConvertMedium }}</p>
  </ng-container>

  <ng-container *ngIf="vendor.insurance_last_verified_date">
    <h6>Insurance Verified Date</h6>
    <p>{{ (vendor.insurance_last_verified_date * 1000) | timezoneConvertMedium }}</p>
  </ng-container>

  <ng-container *ngIf="vendor.insurance_last_verifier">
    <h6>Insurance Verifier</h6>
    <p>
      <a (click)="onUserPublicView(vendor.insurance_last_verifier.hash)" matTooltip="View User Public Profile">
        {{ vendor.insurance_last_verifier.contact_person }}
      </a>
    </p>
  </ng-container>

  <ng-container *ngIf="vendor.notes">
    <h6>Notes</h6>
    <p style="white-space: pre-wrap;">{{ vendor.notes }}</p>
  </ng-container>

  <ng-container *ngIf="vendor.address">
    <h6>Address</h6>
    <p>{{ vendor.address }}</p>
  </ng-container>

  <ng-container *ngIf="vendor.suburb">
    <h6>Suburb</h6>
    <p>{{ vendor.suburb }}</p>
  </ng-container>

  <ng-container *ngIf="vendor.city">
    <h6>City</h6>
    <p>{{ vendor.city }}</p>
  </ng-container>

  <ng-container *ngIf="vendor.postal_code">
    <h6>Postal Code</h6>
    <p>{{ vendor.postal_code }}</p>
  </ng-container>

  <ng-container *ngIf="vendor.country">
    <h6>Country</h6>
    <p>{{ vendor.country }}</p>
  </ng-container>

  <ng-container *ngIf="vendor.created_by_user">
    <h6>Created By</h6>
    <p>
      <a (click)="onUserPublicView(vendor.created_by_user.hash)" matTooltip="View User Public Profile">
        {{ vendor.created_by_user.contact_person }}
      </a>
    </p>
  </ng-container>

  <ng-container *ngIf="vendor.date_created">
    <h6>Created At</h6>
    <p>{{ (vendor.date_created * 1000) | timezoneConvertLong}}</p>
  </ng-container>

  <ng-container *ngIf="vendor.updated_by_user">
    <h6>Last Updated By</h6>
    <p>
      <a (click)="onUserPublicView(vendor.updated_by_user.hash)" matTooltip="View User Public Profile">
        {{ vendor.updated_by_user.contact_person }}
      </a>
    </p>
  </ng-container>

  <ng-container *ngIf="vendor.date_modified">
    <h6>Last Updated At</h6>
    <p>{{ (vendor.date_modified * 1000) | timezoneConvertLong}}</p>
  </ng-container>

  <ng-container *ngIf="vendor?.files?.length">
    <h6>Uploaded Files</h6>
    <app-files-list [view]="true" [files]="vendor?.files"></app-files-list>
  </ng-container>
</mat-dialog-content>

